import React from "react";
import { TrendBadge } from "./TrendBadge";
import { formatNumber } from "../selectors";

/**
 * One headline number for the window, with its movement against the equally
 * long window before it.
 */
export function MetricCard({ icon: Icon, label, value, hint, changePct, accent }) {
  return (
    <div className={`ct-metric ct-metric--${accent || "accent"}`}>
      <div className="ct-metric-head">
        <span className="ct-metric-icon">
          <Icon aria-hidden="true" />
        </span>
        <span className="ct-metric-label">{label}</span>
      </div>
      <div className="ct-metric-value">{formatNumber(value)}</div>
      <div className="ct-metric-foot">
        {changePct === undefined ? null : (
          <TrendBadge pct={changePct} label={label} size="sm" />
        )}
        {hint ? <span className="ct-metric-hint">{hint}</span> : null}
      </div>
    </div>
  );
}
